import Counter from "./Counter"
import Container from "react-bootstrap/Container"

function App() {
  return (
    <Container className="justify-content-md-center">
      <Counter />
    </Container>
  )
}

export default App
